export default {"src":"/_next/static/media/prev-arrow.c3a3a35e.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};